<template>
  <div name="addendums" class="ml-5 mr-5 mb-12">
    <loader :loader="sending" />

    <patient-information :model="model" class="mb-4 mt-4" />
    <v-divider class="mt-8 mb-8"></v-divider>

    <v-row dense>
      <v-col
        class="col-md-2"
        style="text-align: center"
        v-for="(file, index) in addendums"
        :key="file.fileName"
        :id="index"
      >
        <v-icon
          @click="openPDF(file)"
          type="button"
          size="40px"
          :color="
            file.type === 'pdf'
              ? 'error'
              : file.type === 'jpeg' ||
                file.type === 'jpg' ||
                file.type === 'png'
              ? 'secondary'
              : file.type === 'zip' || file.type === 'rar'
              ? 'green'
              : 'grey'
          "
          >{{
            file.type === "pdf"
              ? "mdi-file-pdf-box"
              : file.type === "jpeg" ||
                file.type === "png" ||
                file.type === "jpg"
              ? "mdi-image"
              : file.type === "zip" || file.type === "rar"
              ? "mdi-zip-box"
              : "mdi-file"
          }}</v-icon
        >
        <p style="text-align: center">
          {{ file.fileName }}
        </p>
      </v-col>
    </v-row>
    <v-row v-if="this.$utilFront.isNull(addendums) || addendums.length == 0">
      <v-col>
        <strong>
          <p>No se encontraron archivos</p>
        </strong>
      </v-col>
    </v-row>
    <v-dialog
      v-if="dialogViewer"
      v-model="dialogViewer"
      persistent
      max-width="800px"
      transition="dialog-top-transition"
    >
      <v-card>
        <v-card-title class="text-h6 text-center"> Archivo anexo </v-card-title>
        <v-card-text>
          Nombre: {{ attachedFile.fileName }}
        </v-card-text>

        <div class="container" v-if="attachedFile.type != 'pdf'">
          <div style="justify-content: center" class="row overflow-y-auto">
            <img
              id="imgSign"
              download
              width="auto"
              height="400"
              :src="'data:image/*;base64,' + attachedFile.bytes"
            />
          </div>
        </div>
        <div class="container" v-if="attachedFile.type == 'pdf'">
          <Viewer :file="attachedFile" />
        </div>
        <v-card-actions style="justify-content: center">
          <v-btn color="secondary" text @click="dialogViewer = false">
            <v-icon left>mdi-chevron-left</v-icon>Regresar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="download(attachedFile)"
          >
            Descargar<v-icon right>mdi-download</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PatientInformation from "@/app/components/common/patient/PatientInformation.vue";
import PatientFileRequest from "@/core/request/PatientFileRequest";
import Loader from "@/components/Loader.vue";
import Viewer from "@/app/components/common/PdfViewer/Viewer.vue";

export default {
  props: {
    addendums: Array,
    model: Object,
  },
  components: {
    Loader,
    PatientInformation,
    Viewer
  },
  data() {
    return {
      dialogViewer: false,
      attachedFile: {},
      sending: false,
    };
  },
  mounted() {
    console.log(this.model);
  },
  methods: {
    async openPDF(item) {
      this.attachedFile = item;
      this.dialogViewer = true;
      // this.sending = true;
      // let params = {
      //   idPatientFile: item.idPatientFile,
      //   idPatient: this.model.idPatient,
      //   fileName: item.fileName,
      //   idInterpretation: this.model.idInterpretation
      // };

      console.log(item);
      // PatientFileRequest.findOneAddendumByPatient(params)
      //   .then((response) => {
      //     const {  data, code } = response.data;

      //     if (code == 200 && typeof data === "object") {
      //       this.attachedFile = {
      //         file: data.file,
      //         registrationDate: item.registrationDate,
      //         name: item.fileName,
      //         type: item.type,
      //       };

      //       this.dialogViewer = true;
      //     } else {
      //       this.$utilFront.notifications("Sin acceso al archivo", "ERROR");
      //     }
      //   })
      //   .catch((e) => {
      //     this.$utilFront.errorhttp(e);
      //   })
      //   .finally(() => {
      //     this.sending = false;
      //   });
    },
    download(file) {
      let a = document.createElement("a"); //Create <a>
      a.href = "data:image/png;base64," + file.bytes; //Image Base64 Goes here
      a.download = file.fileName; //File name Here
      a.click(); //Downloaded file
      // const url = URL.createObjectURL(
      //       new Blob([file.bytes], {
      //         type: file.type,
      //       })
      //     );
      //     const link = document.createElement("a");
      //     link.href = url;
      //     link.setAttribute("download", file.fileName);
      //     document.body.appendChild(link);
      //     link.click();

      //     document.body.removeChild(link);
    },
  },
};
</script>

<style></style>
